import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedToolsIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M3 20.9998H7L20 7.99981C20.5304 7.46938 20.8284 6.74996 20.8284 5.99981C20.8284 5.24967 20.5304 4.53025 20 3.99981C19.4696 3.46938 18.7501 3.17139 18 3.17139C17.2499 3.17139 16.5304 3.46938 16 3.99981L3 16.9998V20.9998Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 5.5L18.5 9.5L14.5 5.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 8L7 3L3 7L8 12",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 8L5.5 9.5L7 8Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 12L21 17L17 21L12 16",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 17L14.5 18.5L16 17Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 5.5L18.5 9.5M12 8L7 3L3 7L8 12M7 8L5.5 9.5M16 12L21 17L17 21L12 16M16 17L14.5 18.5M3 20.9998H7L20 7.99981C20.5304 7.46938 20.8284 6.74996 20.8284 5.99981C20.8284 5.24967 20.5304 4.53025 20 3.99981C19.4696 3.46938 18.7501 3.17139 18 3.17139C17.2499 3.17139 16.5304 3.46938 16 3.99981L3 16.9998V20.9998Z",
			stroke: "#30515B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedToolsIcon);
const Memo = memo(ForwardRef);
export default Memo;
